import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=ba774d60&scoped=true&"
import script from "./PreviewFile.vue?vue&type=script&lang=js&"
export * from "./PreviewFile.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFile.vue?vue&type=style&index=0&id=ba774d60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba774d60",
  null
  
)

export default component.exports